import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CASTOR_API_URL } from '../api-config';
import { AuthService } from '../auth/auth.service';
import { CastorCrud, CrudsService } from '../crud-builder/cruds.service';

@Injectable({ providedIn: 'root' })
export class MarketplaceService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private cruds = inject(CrudsService);

  private async headers(): Promise<Record<string, string>> {
    const token = await this.auth.getIdToken();
    const h: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) h['Authorization'] = token;
    return h;
  }

  async listAvailable(customerId: string): Promise<CastorCrud[]> {
    const headers = await this.headers();
    const params = new HttpParams().set('customerId', customerId);
    const res = await firstValueFrom(
      this.http.get<{ items: CastorCrud[] }>(`${CASTOR_API_URL}/marketplace/cruds`, { headers, params })
    );
    return res?.items ?? [];
  }

  async listAssigned(customerId: string): Promise<CastorCrud[]> {
    const headers = await this.headers();
    const params = new HttpParams().set('customerId', customerId);
    const res = await firstValueFrom(
      this.http.get<{ items: CastorCrud[] }>(`${CASTOR_API_URL}/marketplace/assignments`, { headers, params })
    );
    return res?.items ?? [];
  }

  async assign(customerId: string, customerCRUDSId: string): Promise<void> {
    const headers = await this.headers();
    await firstValueFrom(
      this.http.post(
        `${CASTOR_API_URL}/marketplace/assignments`,
        { customerId, customerCRUDSId },
        { headers }
      )
    );
  }

  async removeAssignment(customerId: string, customerCRUDSId: string): Promise<void> {
    const headers = await this.headers();
    const params = new HttpParams().set('customerId', customerId);
    await firstValueFrom(
      this.http.delete(
        `${CASTOR_API_URL}/marketplace/assignments/${encodeURIComponent(customerCRUDSId)}`,
        { headers, params }
      )
    );
  }

  async listAccessibleCruds(customerId?: string): Promise<CastorCrud[]> {
    return this.cruds.listCruds(customerId);
  }
}
